import { useMemo } from 'react';
import { featureCollection } from '@turf/turf';
import { Feature } from 'geojson';
import { ColorKey, SoilLayer } from '../types/soilAttributes';

interface ColorSoilLayerProps {
  colorKey: Nullable<ColorKey>;
  soilLayer: Nullable<SoilLayer>;
}

const useColorSoilLayer = ({ colorKey, soilLayer }: ColorSoilLayerProps) => {
  return useMemo(() => {
    if (!soilLayer) return null;
    if (!colorKey) return soilLayer;
    return {
      ...soilLayer,
      data: featureCollection(
        (soilLayer.data?.features || []).map((f: Feature) => ({
          ...f,
          properties: {
            ...f.properties,
            rgbString:
              colorKey[f.properties?.mapUnitKey] || f.properties?.rgbString,
          },
        })),
      ),
    };
  }, [colorKey, soilLayer]);
};

export default useColorSoilLayer;
